
export class DarkSyntaxHighlight {

    public _Point     = "#000000";
    public _Circle    = "#ffffff";
    public _Sequence  = "#287bff";
    public _Prism     = "#86ff35";
    public _Structure = "#85ceff";
    public _Tree      = "#82e6ff";
    public _Manifold  = "#ffb300";
    public _Function  = "#ff20fa";
    public _Procedure = "#ffc0fa";
    public _Class     = "#ca90ff";

}
